import { checkStatus, download, upgrade } from '@/api/upgrade';
export default {
  namespaced: true,
  state: {
    upgradeInfo: null,
  },

  getters: {
    getSoftwareStatus: (state) => state.upgradeInfo?.status_code,
    getLastVersion: (state) => state.upgradeInfo?.application_version,
    getCurrentVersion: (state) => state.upgradeInfo?.application_current_version,
    getFileSIze: (state) => {
      return {
        total: state.upgradeInfo?.total_file_size,
        current: state.upgradeInfo?.current_file_size,
      };
    },
    getVersionText: (state) => {
      return `<p style="font-size: 1.8rem; margin-bottom: 8px; color: #6b6b6b">目前版號：${state.upgradeInfo?.application_current_version} / 最新版號：${state.upgradeInfo?.application_version}</p>`;
    },
  },

  mutations: {
    SET_DATA(state, data) {
      state.upgradeInfo = data;
    },
  },

  actions: {
    //取得系統版號
    async checkSoftwareStatus({ commit }) {
      const res = await checkStatus();
      commit('SET_DATA', res);
      return Promise.resolve();
    },
    //執行下載
    async softwareDownload() {
      await download();
      return Promise.resolve();
    },
    //執行更新
    async softwareUpgrade() {
      await upgrade();
      return Promise.resolve();
    },
  },
};
